import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Collapse from '@mui/material/Collapse';
import CheckIcon from '@mui/icons-material/Check';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import File from '../../../components/widgets/WidgetFile';
import Document from './Document';
import Dropzone from '../../../components/widgets/WidgetDropZone';
import axios from "axios";
import CONFIG from '../../../config';
import GroupState from './GroupState';

function GroupDocument({ user, setUser, groupIcon, groupName, documents }) {
  const [collapse, setCollapse] = React.useState(false);

  const states = documents.map((documentData) => {
    var document = null;
    if (documentData.type_dossier == 'deuxieme_locataire') {
      document = user.dossier.deuxieme_locataire.documents[documentData.document_name];
    } else if (documentData.type_dossier == 'dossier') {
      document = user.dossier.documents[documentData.document_name];
    } else {
      document = user.dossier.list_garants[documentData.type_dossier].documents[documentData.document_name];
    }

    return document.etat;
  });
  const facultatifList = documents.map((documentData) => documentData.facultatif);

  if (documents.length === 0)
    return;


  return (
    <>
      <div className='col-span-12 w-full grid grid-cols-12 gap-x-4 shrink-0'>
        <div className='col-span-12 grid grid-cols-12 p-6 hover:bg-gray-100 cursor-pointer' onClick={() => setCollapse(!collapse)}>
          <div className='flex col-span-8 w-full items-end'>
            <div className='pr-2 text-ame-gray'>
              {groupIcon}
            </div>
            <div>
              <h3>{groupName}</h3>
            </div>
          </div>

          <GroupState etatList={states} facultatifList={facultatifList} />
        </div>
        <div className='col-span-12 w-full px-6 shadow-inner shadow-gray-100 bg-gray-50'>
          <Collapse in={collapse}>
            {documents.map((document) => (
              <Document key={document.titre} user={user} setUser={setUser} title={document.titre} description={document.description} type_dossier={document.type_dossier} document_name={document.document_name} facultatif={document.facultatif}></Document>
            ))}
          </Collapse>
        </div>
      </div>
    </>
  );
}

export default GroupDocument;